import { Flags } from "@/providers/LaunchDarklyProvider";
import { useFlags } from "launchdarkly-react-client-sdk";
import { MobileVoicePage } from "./MobileVoicePage";
import { MobileVoicePageV2 } from "./MobileVoicePageV2";

/**
 * `/m/voice` gate: the live-transcription voice experience (streaming
 * transcript, session chaining, destinations) requires the `live-transcription`
 * backend flag — without it the WS endpoint 403s — so flag-off orgs keep the
 * original record → one-shot transcribe page.
 */
export function MobileVoiceGate() {
  const flags = useFlags<Flags>();
  return flags.liveTranscription === true ? (
    <MobileVoicePageV2 />
  ) : (
    <MobileVoicePage />
  );
}

export default MobileVoiceGate;
